<template>
  <el-aside :width="isCollapsed ? '64px' : '200px'" class="app-sidebar">
    <div class="sidebar-top">
      <img v-if="!isCollapsed" class="logo" src="@/assets/header/logo_yhw.png" alt="">
      <img v-else class="logoCollapsed" src="@/assets/header/logo_yhw1.png" alt="">
    </div>
    <el-menu
        :default-active="activePath"
        class="sidebar-menu"
        :collapse="isCollapsed"
        router
        text-color="#3d404b"
        active-text-color="#f2f9f7"
    >
      <template v-for="item in menuRoutes">
        <subItem :key="item.path" :item="item"></subItem>
      </template>
    </el-menu>
  </el-aside>
</template>

<script>
import subItem from '@/layout/subItem.vue'

export default {
  name: 'AppSidebar',
  components: {
    subItem
  },
  data() {
    return {
      menuRoutes: []
    }
  },
  computed: {
    isCollapsed() {
      return this.$store.state.sidebar.isCollapsed
    },
    activePath() {
      return this.$route.meta.activeMenu || this.$route.fullPath
    }
  },
  mounted() { console.log(this.$store)
    this.menuRoutes = this.getRoutes(this.$router.options.routes)
  },
  methods: {
    getRoutes(childs) {
      if (!childs || childs.length === 0) {
        return []
      }
      return childs.filter(item => !item.hidden && (item.children && item.children.length > 0 || item.meta))
          .map(item => {
            if (item.children && item.children.length > 0) {
              item.children = this.getRoutes(item.children)
            }
            return item
          })
          .filter(item => item.meta && item.meta.title && item.meta.icon)
    },
  }
}
</script>

<style scoped lang="scss">
.app-sidebar {
  background-color: #ffffff;
  transition: width 0.3s;
  overflow-x: hidden;

  .sidebar-top {
    height: 60px;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    background: url("@/assets/header/logo_di.png") no-repeat;
    background-size: 200px 60px;
    background-position: center center;

    .logo {
      width: 140px;
      height: 38px;
    }

    .logoCollapsed {
      width: 36px;
      height: 35px;
    }
  }

  .sidebar-menu {
    border-right: none;
  }
}
</style>